@let expenses = ($expenses | async) || [];
<!---->
@let fetched = ($fetched | async);
<!---->
@if (!fetched) {
<loading title="Fetching user expenses..." />
}
<!---->
@if (error) {
<app-alert (close)="error = null" type="error" class="mt-3">{{
  error
}}</app-alert>
}
<!---->
@if (fetched && expenses.length) {
<!---->
@for (expense of expenses; track $index) {
<mat-card class="mt-3 ms-3" appearance="outlined">
  <mat-card-content>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div>{{ expense.name }}</div>
        <div class="small">{{ expense.description }}</div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-items: center;
          justify-content: center;
        "
      >
        @if (loadingExpenseId == expense.id) {
        <mat-progress-spinner
          mode="indeterminate"
          color="primary"
          diameter="30"
        />
        } @else {

        <!---->
        @if(expense.isAcknowledgementOfDebt && doesUserHaveExpense(expense)) {
        <div
          [class]="
            getUserExpense(expense)?.acknowledgementOfDebt?.status + '-text'
          "
        >
          <div class="d-flex align-items-center">
            {{ getUserExpense(expense)?.acknowledgementOfDebt?.status }}
          </div>
        </div>

        <button mat-icon-button (click)="openAodDialog(expense)" class="me-2">
          <mat-icon>visibility</mat-icon>
        </button>
        }
        <mat-slide-toggle
          [checked]="doesUserHaveExpense(expense)"
          (toggleChange)="onToggleExpense(expense)"
        >
        </mat-slide-toggle>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
}
<!---->
}
<!---->
@if (fetched && !expenses.length) {
<div class="center">
  <div class="d-flex align-items-center">
    <mat-icon class="me-2">payment</mat-icon>
    <div>There are no expenses</div>
  </div>
  <button
    mat-raised-button
    color="primary"
    class="mt-3"
    (click)="onNavToExpensesClicked()"
  >
    Add Expenses
  </button>
</div>
}
